import { proxy } from 'valtio';
import { valtioDevTools } from '@lib/utils/devTools';
import type { TechnicianTableRow } from './types';

export type TechniciansState = {
  technicians: TechnicianTableRow[];
  technicianById: Map<string, TechnicianTableRow>;
  techniciansLoading: boolean;
  techniciansLoadFailed: boolean;
  techniciansHasPartialError: boolean;
};

export const techniciansState = proxy<TechniciansState>({
  technicians: [],
  technicianById: new Map(),
  techniciansLoading: false,
  techniciansLoadFailed: false,
  techniciansHasPartialError: false,
});

valtioDevTools(techniciansState, 'techniciansState');
